import { executeSupabaseEdgeFunction } from ".";

export interface ERN {
  number: string;
  description: string;
  createdBy: string;
  fileUrl: string;
  bomData: ERNBomLine[];
}

export interface ERNBomLine {
  lineNumber: number;
  itemId?: number;
  itemName?: string;
  description?: string;
  quantity?: number;
  unitOfMeasure?: string;
  actionRequired?: string;
  comments?: string;
  hierarchyLevel?: number;
}

export async function getERNSforJob(jobNumber: string): Promise<ERN[]> {
  return await executeSupabaseEdgeFunction<ERN[]>(`api/erns/${jobNumber}`, { method: "GET" });
}
